import { withProps } from 'recompose'

import Testimonial from 'layouts/Testimonial'

import nameIconSrc from './mike-volpe.svg'
import faceIconSrc from './mike_face.png'

export default withProps({
  role: 'CEO',
  nameIconSrc,
  faceIconSrc,
  quote: `
    Businesses spend so much time and effort driving people to their websites,
    but once they get them there, nothing happens. But with Drift, you can actually talk to
    those people while they’re live on your site. That’s the easiest way to fix your conversion
    problems.
  `,
  company: 'Lola',
})(Testimonial)
